module.exports = __webpack_public_path__ + "static/media/dm1.bc208ed2.webp";